var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.175 13.371.45-2.957h-2.86V8.486c0-.836.385-1.607 1.67-1.607h1.319v-2.54s-1.19-.225-2.315-.225c-2.346 0-3.889 1.447-3.889 4.018v2.282H8.914v2.957h2.636v7.2h3.214v-7.2h2.411Z",
    fill: "#fff"
  })));
};
export default SvgIconFacebook;